module.exports = __webpack_public_path__ + "img/bootstrap_logo.ed84878d.png";